const config = {
  borderRadius: '4px'
};

export default config;
